import _ from 'lodash'

export const scoreToText = (score: number | undefined | null, decimalDigits = 0): string => {
  if (!_.isNumber(score)) {
    return 'unknown'
  }

  const scoreAsPercentage = _.round(score * 100, decimalDigits)

  return `${scoreAsPercentage}%`
}
